function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7.847 9.097a.11.11 0 00-.154 0l-1.589 1.589a1.964 1.964 0 01-2.789 0 1.964 1.964 0 010-2.79l1.589-1.588a.11.11 0 000-.154l-.544-.545a.11.11 0 00-.155 0L2.617 7.2a2.956 2.956 0 000 4.183 2.957 2.957 0 004.183 0L8.39 9.793a.11.11 0 000-.154l-.542-.542zm3.536-6.48a2.956 2.956 0 00-4.184 0L5.61 4.205a.11.11 0 000 .155l.543.543a.11.11 0 00.155 0l1.588-1.589a1.964 1.964 0 012.79 0 1.964 1.964 0 010 2.789l-1.59 1.589a.11.11 0 000 .154l.545.544a.11.11 0 00.154 0l1.589-1.588a2.96 2.96 0 000-4.185zM8.341 5.09a.11.11 0 00-.154 0L5.09 8.185a.11.11 0 000 .155l.541.541a.11.11 0 00.155 0L8.88 5.786a.11.11 0 000-.155l-.54-.541z",
  fill: "currentColor"
});

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
}

export default SvgLink;